import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators';
import { IEntity } from '@dch/entity-manager';
import { ODB_BILL_CATEGORY_DETAILS_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getOdbCategoryDetailsRequest,
  getOdbCategoryDetailsSuccess,
  getOdbCategoryDetailsFailure,
} from '../actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';
import {
  OdbCoverDetailDivisionType,
  IOdbBillCategoryDetailsResponse,
} from '@dch/billing-business-logic';

@Injectable()
export class OdbCategoryDetailsEffects {
  getOdbCategoryDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getOdbCategoryDetailsRequest),
      withLatestFrom(this.store.select(selectCustomer)),
      mergeMap(
        ([
          {
            documentReference,
            category,
            billingAccountNumber,
            divisionType,
            divisionIdentifier,
          },
          { customerId },
        ]) =>
          EntityManager.getEntity<IOdbBillCategoryDetailsResponse>(
            this.getEntityConfigWithDivisionParamsInUrl(
              ODB_BILL_CATEGORY_DETAILS_ENTITY,
              divisionType,
              divisionIdentifier
            ),
            {
              cdbId: customerId,
              billingAccountNumber,
              documentReference,
              category,
            }
          ).pipe(
            map((entity) =>
              entity.value
                ? getOdbCategoryDetailsSuccess({
                    documentReference,
                    category,
                    payload: entity.value,
                  })
                : getOdbCategoryDetailsFailure({
                    documentReference,
                    category,
                  })
            ),
            catchError((error) =>
              of(
                getOdbCategoryDetailsFailure({
                  documentReference,
                  category,
                })
              )
            )
          )
      )
    )
  );

  getEntityConfigWithDivisionParamsInUrl(
    entity: IEntity<IOdbBillCategoryDetailsResponse>,
    divisionType?: OdbCoverDetailDivisionType,
    divisionIdentifier?: string
  ): IEntity<IOdbBillCategoryDetailsResponse> {
    let newEntity = { ...entity };

    if (divisionType !== undefined || divisionIdentifier !== undefined) {
      newEntity.url += '?';

      if (divisionType) {
        newEntity.url += 'type=' + divisionType;
      }

      if (divisionIdentifier) {
        if (divisionType) {
          newEntity.url += '&';
        }
        newEntity.url += 'identifier=' + divisionIdentifier;
      }
    }
    return newEntity;
  }

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
